import { IDiscount } from "./discount.interface";

export class DiscountDto
  implements Omit<IDiscount, "_id" | "club_id" | "event_id">
{
  discount_code: string;
  discount_type: string; //Amount/Percentage
  discount_value: number;
}
